import request from '../utils/request'

/**
 * 商品相关接口
 */

// 获取商品详情
export function getGoodsDetail(id) {
  return request({
    url: `/h5/goods/${id}`,
    method: 'get'
  })
}

// 获取商品分类列表
export function getCategoryList() {
  return request({
    url: '/h5/goods/categories',
    method: 'get'
  })
}

// 获取分类下商品
export function getCategoryGoods(params) {
  return request({
    url: '/h5/goods/list',
    method: 'get',
    params
  })
}

// 获取商品评价列表
export function getGoodsComments(goodsId, params) {
  return request({
    url: `/h5/goods/${goodsId}/comments`,
    method: 'get',
    params
  })
}

// 获取热门商品
export function getHotGoods(params) {
  return request({
    url: '/h5/goods/hot',
    method: 'get',
    params
  })
}
